import { useEffect } from "react";
import { Box } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button, Select, Modal, ConfigProvider } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRequest,
  bulkUpdateFilter,
  bulkUpdateField,
  bulkUpdateFilterBack,
  bulkUpdateSubmit,
} from "../../../store/actions/alertsShipment";
import bulkupdatealerticon from "../../../assets/bulkupdatealerticon.svg";
import { ArrowLeftOutlined } from "@ant-design/icons";

const AlertsBulkDetails = ({ visible, selectedItems, closePopup,setSelectedItems }) => {
  const dispatch = useDispatch();

  const filters = useSelector((state) => state.alertsShipment.filters);
  const statuses = useSelector((state) => state.alertsShipment.bulkUpdate.statuses);

  const isFiltered = useSelector((state) => state.alertsShipment.bulkUpdate.isFiltered);
  const isFiltering = useSelector(
    (state) => state.alertsShipment.bulkUpdate.isFiltering
  );
  const fields = useSelector((state) => state.alertsShipment.bulkUpdate.fields);

  const filterCount = useSelector(
    (state) => state.alertsShipment.bulkUpdate.filters.count
  );

  useEffect(() => {
    if (!visible) {
      dispatch({ type: "RESET_BULK_UPDATE_FORM" });
    }
  }, [visible, dispatch]);

  const handleInputFieldChange = (field, value) => {
    dispatch(bulkUpdateField({ [field]: value }));
  };

  const handleBackButton = () => {
    dispatch(bulkUpdateFilterBack());
  };

  const handleSubmitFilter = () => {
    dispatch(bulkUpdateFilter(true));
  };

  const handleSubmitUpdate = async () => {
    // if (filterCount > 0) {
    dispatch(bulkUpdateSubmit(selectedItems));
    setSelectedItems([])
      let statusValue = {
        "Acknowledged": false,
        "Auto Resolved": false,
        "New": true,
        "Resolved": false
      };
      const filterArr = Object.entries(statusValue);
  
      if (filterArr.length === 0) {
        return;
      }
  
      const filterValue = filterArr.map((filter) => ({
        text: filter[0],
        value: filter[1],
      }));
  
      dispatch(
        fetchRequest({
          ...filters,
          status: filterValue,
        })
      );
    // }
   
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setSelectedItems([])
    dispatch(bulkUpdateFilterBack());
    closePopup(false);
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#000000",
          controlOutlineWidth: 0.1,
        },
      }}
    >
      <Modal
        visible={visible}
        onCancel={handleCloseModal}
        loading={isFiltering}
        footer={[
          <Grid2
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                {!isFiltered && (
                  <Button
                    className="custom-button-cancel"
                    type="default"
                    onClick={handleCloseModal}
                    shape="round"
                    style={{ fontWeight: "bold", width: "100%" }}
                    size={"large"}
                  >
                    <div style={{ fontFamily: "VerizonNHGDS" }}>Cancel</div>
                  </Button>
                )}

                {isFiltered && (
                  <Button
                    className="custom-button-cancel"
                    type="default"
                    onClick={handleBackButton}
                    shape="round"
                    style={{ fontWeight: "bold", width: "100%" }}
                    size={"large"}
                  >
                    <div style={{ fontFamily: "VerizonNHGDS" }}>Go back</div>
                  </Button>
                )}
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                {!isFiltered && (
                  <Button
                    className="custom-button-save"
                    type="primary"
                    onClick={handleSubmitFilter}
                    shape="round"
                    style={{
                      width: "100%",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    size={"large"}
                    disabled={!fields.status}
                  >
                    <div style={{ fontFamily: "VerizonNHGDS" }}>Update</div>
                  </Button>
                )}

                {isFiltered && (
                  <Button
                    className="custom-button-save"
                    type="primary"
                    onClick={handleSubmitUpdate}
                    shape="round"
                    style={{
                      width: "100%",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold",
                    }}
                    size={"large"}
                  >
                    <div style={{ fontFamily: "VerizonNHGDS" }}>
                      Update {selectedItems?.length} alerts
                    </div>
                  </Button>
                )}
              </div>
            </Grid2>
          </Grid2>,
        ]}
        width={600}
      >
        {isFiltered && (
          <button className="bulkupdate-modal-back" onClick={handleBackButton}>
            <ArrowLeftOutlined />
          </button>
        )}
        <Box className="bulkalert-modal-content">
          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div style={{ marginBottom: "10px" }}>
              <h2 className={"font-face-vzb page-heading-user"}>Alert</h2>
              <div
                style={{
                  fontFamily: "VerizonNHGDS",
                  fontSize: "32px",
                  fontWeight: "700 !important",
                  marginTop: "-10px",
                  paddingTop: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "left",
                }}
              >
                <span className="font-face-vzw">
                  Bulk Edit
                </span>
              </div>
            </div>
          </Grid2>
          {!isFiltered && (
            <>
              <p style={{
                fontFamily: "VerizonNHGDS",
                fontSize: "16px",
                marginTop: "-10px",
                fontWeight: "400 !important",
              }}>
                Enter the new status for the {selectedItems.length} selected alerts to update.
              </p>
              <Box sx={{ mb: 3 }}>
                <Grid2 item xs={6}>
                  <div className="mb-2">
                    <label htmlFor="organization" className="input-label-user">
                      <span style={{
                        textTransform: "uppercase",
                        color: "#6F7171",
                        fontWeight: "400 !important",
                        fontSize: "12px",
                      }}>
                        New Status
                      </span>
                    </label>
                    <div className="input-container mb-3">
                      <Select
                        className="alert-box-size"
                        value={fields?.status}
                        onChange={(value) =>
                          handleInputFieldChange("status", value)
                        }
                        options={statuses
                          .filter((status) => status.value !== "")
                          .map((status) => ({
                            value: status.value,
                            label: status.label,
                          }))}
                      />
                    </div>
                  </div>
                </Grid2>
              </Box>

            </>
          )}
          {isFiltered && (
            <div>
              <div className="alert-bulkupdate-msgbox">
                <div className="alert-bulkupdate-msg-header">
                  <img src={bulkupdatealerticon} alt="bulkupdatealerticon" />
                  <span className="font-face-vzb">View alerts</span>
                </div>
                <div className="alert-bulkupdate-msg">
                  {selectedItems?.length} alerts match the query and will be updated.
                </div>
              </div>
              <p>Are you sure you would like to update {filterCount} alerts?</p>
            </div>
          )}
        </Box>

      </Modal>
    </ConfigProvider>
  );
};

export default AlertsBulkDetails;
